var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.$common.getStyleName('pack-componesnts')},[(_vm.$modulList.pack === 1)?_c('div',{class:_vm.$common.getStyleName('pack-1')},[_c('Pack1')],1):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-56fd7c70","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href","my-custom-element":["attribute-to-transform-to-require","another-attribute-to-transform-to-require"]},"buble":{"transforms":{}}}!./~/vue-loader/lib/selector.js?type=template&index=0!./website/components/package/packs/Index.vue
// module id = 4iZp
// module chunks = 0